module.exports = __webpack_public_path__ + "img/herb-parsley-350x184.4fb0a817.jpg";